import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { ILink } from '../../services/link/types';
import OnboardingBackground from '../../components/OnboardingBackground';
import OnboardingCardTemplate from '../../components/OnboardingCardTemplate';
import { Body } from '../../components/Text';
import AppHands from '../../assets/icons/app_hands.svg';
import ReceiptService from '../../services/receipts/service';
import { IShareTokenResponse } from '../../services/receipts/types';
import { useAmplitude } from '../../providers/AmplitudeProvider';
import {
    onWebAppShareLinkLoaded,
    onWebAppShareAcceptClicked,
    // onWebAppShareContinueInAppClicked,
} from '../../tracking/trackers';
// import FolderCard from '../../../components/FolderCard';
import ReceivedSharesGrid from './components/ReceivedSharesGrid';

const DynamicLink = ({
    linkToken,
    tokenData,
}: {
    linkToken: string;
    tokenData: ILink;
}) => {
    const navigate = useNavigate();
    const { isInitialized } = useAmplitude();

    const [categoriesInvitations, setCategoriesInvitations] = useState<
        IShareTokenResponse | undefined
    >();

    useEffect(() => {
        ReceiptService.getShareToken(linkToken)
            .then((response) => {
                setCategoriesInvitations(response);
            })
            .catch((e) => {
                console.error('Error in loading share link!', e);
                setCategoriesInvitations({
                    status: 'error',
                    error:
                        e?.response?.data?.error ||
                        'Error in loading share link!',
                });
            });
    }, []);

    const onAccept = () => {
        onWebAppShareAcceptClicked({
            share_token: linkToken,
        });
        navigate(
            '/signup?manualCodeEntry=true&variant=share&share_token=' +
                linkToken +
                '&suggested_mobile=' +
                (tokenData?.metadata?.metadata_mobile ||
                    tokenData?.metadata?.mobile)
        );
    };

    // const _onContinue = () => {
    //     onWebAppShareContinueInAppClicked({
    //         share_token: linkToken,
    //     });
    //     navigate('/redirect-download', {
    //         state: {
    //             alternativeWebUrl: '/link/share',
    //             customData: {
    //                 link_token: linkToken,
    //             },
    //         },
    //     });
    // };

    const sourceName =
        categoriesInvitations?.data?.invitations?.[0]?.source_user
            ?.first_name || 'Someone';

    const cohort: string = 'accept-page';

    useEffect(() => {
        if (isInitialized && categoriesInvitations) {
            onWebAppShareLinkLoaded({
                share_token: linkToken,
                link_type: tokenData?.link_type,
                status: categoriesInvitations.status,
                error: categoriesInvitations.error,
                user: {
                    id: categoriesInvitations?.data?.invitations?.[0]
                        ?.source_user?.id,
                    mobile: categoriesInvitations?.data?.invitations?.[0]
                        ?.source_user?.mobile,
                },
                categories: categoriesInvitations?.data?.invitations?.map(
                    (c) => c?.category?.tag_id || ''
                ),
                metadata: tokenData?.metadata,
                cohort,
            });
        }
    }, [isInitialized, categoriesInvitations, cohort]);

    return (
        <>
            {!categoriesInvitations || cohort === 'no-accept-page' ? (
                <OnboardingBackground>
                    <OnboardingCardTemplate
                        content={
                            <div
                                style={{
                                    paddingTop: '25%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <CircularProgress
                                    color={'primary'}
                                    style={{
                                        width: 24,
                                        height: 24,
                                    }}
                                />
                                <div style={{ margin: 5 }} />
                                <Body
                                    style={{
                                        fontSize: 14,
                                    }}
                                >
                                    Loading...
                                </Body>
                            </div>
                        }
                    />
                </OnboardingBackground>
            ) : categoriesInvitations.status === 'error' ? (
                <OnboardingBackground>
                    <OnboardingCardTemplate
                        title={categoriesInvitations.error}
                        content={
                            <>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    <img
                                        src={AppHands}
                                        alt=""
                                        width={150}
                                        height={150}
                                        style={{ marginTop: 30 }}
                                    />
                                    <div
                                        style={{
                                            margin: 10,
                                            textAlign: 'center',
                                        }}
                                    >
                                        The sharing link you are trying to
                                        access is not valid. Please ask the
                                        sender to regenerate the link!
                                    </div>
                                </div>
                            </>
                        }
                        style={{
                            paddingTop: '5%',
                        }}
                    />
                </OnboardingBackground>
            ) : (
                <OnboardingBackground>
                    <OnboardingCardTemplate
                        title={`Share Receipts with ${sourceName}`}
                        width={'100%'}
                        content={
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <div style={{ flex: 1, margin: 30 }} />
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        maxWidth: 250,
                                    }}
                                >
                                    Accept folder invites to share receipts in
                                    real-time
                                </div>
                                <div style={{ flex: 1, margin: 30 }} />
                                <ReceivedSharesGrid
                                    invitations={
                                        categoriesInvitations.data
                                            ?.invitations || []
                                    }
                                    doSlice
                                />
                                <div style={{ flex: 1, margin: 10 }} />
                            </div>
                        }
                        buttons={[
                            {
                                text: 'Accept',
                                style: {
                                    marginBottom: 30,
                                    width: '95%',
                                    alignSelf: 'center',
                                },
                                onClick: onAccept,
                            },
                        ]}
                    />
                </OnboardingBackground>
            )}
        </>
    );
};

export default DynamicLink;
